import * as angular from "angular";
import { portfolioadmin } from "./portfolioadmin";
import { portfolioManagement } from "./portfolio/portfolioadmin.portfolio";
import { tradesGrid } from "./components/tradesGrid";
import { transactionsGrid } from "./components/transactionsGrid";
import { portfolioCashTransactions } from "./cashTransactions/portfolioadmin.cashTransactions";
import { portfolioTrades } from "./trades/portfolioadmin.trades";
import { ClientRepo } from "@services/clients/client.repo";
import { PortfolioRepo } from "@services/portfolio.repo";
import { portfolioManagementSummary } from "./summary/portfolioadmin.summary";
import { portfolioManagementPerformance } from "./performanceManagement/portfolioadmin.performance";
import { portfolioTradeRecommendations } from "./tradeRecommendations/portfolioAdmin.tradeRecommendations";
import { cashTransactionDialog } from "./performanceManagement/editCashTransactionDialog/editCashTransaction.dialog";
import { createCashTransactionDialog } from "./performanceManagement/createCashTransactionDialog/createCashTransaction.dialog";
import { portfolioManagementReport } from "./reportManagement/portfolioadmin.reports";
import { generateReportDialog } from "./reportManagement/monthlyReportDialog/generateMonthlyReport.dialog";
import { tradePreviewDialog } from "./tradeRecommendations/tradePreview.dialog";
import { performanceParameterDialog } from "./performanceManagement/updatePerformanceParameterDialog/updatePerformanceParameter.dialog";
import { tradeDetailsModal } from "./tradeRecommendations/tradeDetails.modal";
import { assetClassList } from "@common/assetClassList.component";
import { assetClassSummary } from "@common/assetClassSummary.component";
import { emailSelectDialog } from "./reportManagement/emailSelectDialog/emailSelect.dialog";
import { echartPieChart } from "@common/echartPieChart.component";
import { SecurityDialog } from "./tradeRecommendations/security.dialog";
import { itemList } from "@common/itemList.component";
import { graphBreakdown } from "@common/graphbreakdown.component";
import { custodianReportDialog } from "./reportManagement/custodianReportDialog/custodianReport.dialog";
import { emailReportsDialog } from "./reportManagement/emailReportsDialog/emailReports.dialog";
import { yearlyTransactionDialog } from "./performanceManagement/yearlyTransactionDialog/yearlyTransaction.dialog";
import { attribution } from "./attribution/attribution";
import { AttributionRepo } from "@services/attribution.repo";
import { benchmarkAttribution } from "./benchmarkAttribution/benchmarkAttribution";
import { benchmarkAttributionEditDialog } from "./benchmarkAttribution/benchMarkAttributionEditDialog/benchMarkAttributionEdit.dialog";
import { modifyDietzDialog } from "./attribution/modify-dietz-dialog/modify-dietz.dialog";
import { assetClassAttribution } from "./attribution/asset-class-attribution/asset-class-attribution";
import { portfolioAttributionReport } from "./reportManagement/portfolioAttribution/portfolioattribution.report";
import { ReportsRepo } from "@services/reports.repo";
import { UsersRepo } from "@services/users.repo";
export const portfolioadminModule = "portfolioadmin";

angular
  .module(portfolioadminModule, [
    "ui.router",
    "dataGrid",
    "pagination",
    "angular-loading-bar",
    "angularModalService",
    "isoCurrency",
    "ngMessages",
  ])
  .component("portfolioadmin", portfolioadmin)
  .component("portfolioManagement", portfolioManagement)
  .component("tradesGrid", tradesGrid)
  .component("transactionsGrid", transactionsGrid)
  .component("portfolioCashTransactions", portfolioCashTransactions)
  .component("portfolioTrades", portfolioTrades)
  .component("portfolioManagementSummary", portfolioManagementSummary)
  .component("portfolioManagementPerformance", portfolioManagementPerformance)
  .component("cashTransactionDialog", cashTransactionDialog)
  .component("createCashTransactionDialog", createCashTransactionDialog)
  .component("portfolioManagementReport", portfolioManagementReport)
  .component("portfolioTradeRecommendations", portfolioTradeRecommendations)
  .component("generateReportDialog", generateReportDialog)
  .component("tradePreviewDialog", tradePreviewDialog)
  .component("performanceParameterDialog", performanceParameterDialog)
  .component("assetClassList", assetClassList)
  .component("assetClassSummary", assetClassSummary)
  .component("itemList", itemList)
  .component("graphBreakdown", graphBreakdown)
  .component("echartPieChart", echartPieChart)
  .component("tradeDetailsModal", tradeDetailsModal)
  .component("emailSelectDialog", emailSelectDialog)
  .component("emailReportsDialog", emailReportsDialog)
  .component("securityDialog", SecurityDialog)
  .component("custodianReportDialog", custodianReportDialog)
  .component("yearlyTransactionDialog", yearlyTransactionDialog)
  .component("benchmarkAttributionEditDialog", benchmarkAttributionEditDialog)
  .component("attribution", attribution)
  .component("assetClassAttribution", assetClassAttribution)
  .component("benchmarkAttribution", benchmarkAttribution)
  .component("modifyDietzDialog", modifyDietzDialog)
  .component("portfolioAttributionReport", portfolioAttributionReport)
  .service("portfolioadminRepo", PortfolioRepo)
  .service("attributionRepo", AttributionRepo)
  .service("clientRepo", ClientRepo)
  .service("reportsRepo", ReportsRepo)
  .service("usersRepo", UsersRepo);



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/portforlioadmin.index.ts